module.exports = __webpack_public_path__ + "static/search2-9cf2ede20908c2a4e0002f84757f1a16.png";